/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import {
  Alert, Box, Button, TextField, Typography,
} from '@mui/material';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase/firebase';

const TranscriptInfoPage = () => {
  const [fileData, setFileData] = useState(JSON.parse(localStorage.getItem('data')));
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [info, setInfo] = useState('');
  const [moreInfo, setMoreInfo] = useState(JSON.parse(localStorage.getItem('moreInfo')));
  const navigate = useNavigate();

  const handleSubmit = async () => {
    const colRef = collection(db, 'transcription');
    if (name && email) {
      await addDoc(colRef, {
        name,
        email,
        phone,
        info,
        price: moreInfo.price,
        fileName: fileData[0].name,
        fileDuration: fileData[0].duration,
        fileURL: fileData[0].url,
        expressOrder: moreInfo.expressOrder,
        timeStamps: moreInfo.timeStamps,
        verbatimStyle: moreInfo.verbatimStyle,
        createdAt: serverTimestamp(),
      })
        .then(() => {
          setFail(false);
          setSuccess(true);
          setName('');
          setEmail('');
          setPhone('');
          setInfo('');
        })
        .catch((err) => {
          setFail(true);
          setErrorMessage(err.message);
        });
    } else {
      setFail(true);
      setErrorMessage('Both Name & Email are required - we need this info when delivering your order');
    }
  };

  return (
    <Box sx={{
      height: '100vh', width: '100%', backgroundColor: '#F5F8FA', padding: '40px 0',
    }}
    >
      <Box sx={{
        width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}
      >
        <Typography sx={{ width: { xs: '100%', sm: '40%' }, fontWeight: '200', fontSize: { xs: '20px', sm: '30px' } }}>Please Provide Details To Which Your Order Will Be Delivered</Typography>
      </Box>
      <Box
        component="form"
        sx={{
          mt: 1, width: { xs: '90%', sm: '30%' }, margin: '30px auto', display: 'flex', flexDirection: 'column', gap: '12px',
        }}
      >
        <TextField type="text" value={name} onChange={(e) => setName(e.target.value)} fullWidth label="Full Name" id="fullWidth" />
        <TextField type="email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth label="Email Address" id="fullWidth" />
        <TextField type="number" value={phone} onChange={(e) => setPhone(e.target.value)} fullWidth label="Your Phone (Optional)" id="fullWidth" />
        <textarea
          style={{
            width: '100%', padding: '15px', border: '2px solid #BCBFC0', borderRadius: '5px', outline: 'none', background: 'transparent', lineHeight: '20px', color: '#000',
          }}
          value={info}
          onChange={(e) => setInfo(e.target.value)}
          rows="5"
          cols="15"
          placeholder="Additional information you'd want us to consider about your transcripts - this can be some specific instructions about speaker identification, time stamps every 30 seconds - etc"
        />
        {!success ? <Button variant="contained" onClick={handleSubmit}>Proceed To Checkout</Button> : <Button variant="contained" onClick={() => navigate('/')}>Back To Website</Button>}
      </Box>
      {success && <Alert sx={{ width: '30%', margin: '20px auto' }} severity="success">Your Order was placed successfully - Please check your email for a reciept</Alert>}
      {fail && <Alert sx={{ width: '30%', margin: '20px auto' }} severity="error">{errorMessage}</Alert>}
    </Box>
  );
};

export default TranscriptInfoPage;
